import * as React from 'react';

const Code = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={22} height={22} viewBox="0 0 22 22" {...props}>
        <g
            fill="none"
            fillRule="evenodd"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.3}
        >
            <path d="M4.125 7.873h16.25M1.625 15.373h16.25M11 1.623l-6.25 18.75M17.25 1.623 11 20.373" />
        </g>
    </svg>
);
export default Code;
